(ns app.front.view.application-wizard.end
  "Splash screen shown after an application has been successfully submitted, or a
   pre-consultation workspace created, from the wizard."
  (:require ["@carbon/icons-react/es/checkmark--outline/32" :default CheckmarkOutline32]
            [app.domain.group.model :as group-model]
            [app.front.view.application-wizard.subs :as subs]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]))

(defn- end-view [_]
  (let [tr             (<sub [::ws-subs/tr])
        match          (<sub [:route/match])
        pre-con?       (= "pre-consultation" (-> match :parameters :query :type))
        workspace-id   (<sub [::subs/workspace-id])
        workspace      (<sub [::subs/workspace])
        application    (<sub [::subs/application])
        issued?        (and (not pre-con?)
                            (= :process.state/permit-issued (:process/state application)))
        issuing?       (and (not pre-con?)
                            (not issued?)
                            (<sub [::subs/express-issuance-pending?]))
        recipient-name (some-> workspace :domain/authority-group group-model/format-long-name not-empty)
        site-address   (:workspace/address workspace)
        proceed-route  (if pre-con? :view/workspace-pre-consultation :view/workspace)]
    [:div.cloudpermit-page
     [:div.max-w-2xl.mx-auto.my-12
      [:h1.text-center.text-4xl.font-bold.mb-8
       (tr [(cond
              pre-con? :application-wizard/end-pre-consultation-title
              issued?  :application-wizard/end-issued-title
              issuing? :application-wizard/end-issuing-title
              :else    :application-wizard/end-title)])]
      [:div.bg-white.rounded.border.border-solid.border-gray-300.px-8.py-10.flex.flex-col.items-center
       (if issuing?
         [:div.mb-8 (cc/loading-spinner {:with-overlay false})]
         [:> CheckmarkOutline32 {:className "w-16 h-16 text-green-600 mb-8"}])
       [:p.text-center.text-gray-800.mb-6
        (cond
          issued?
          (if site-address
            (tr [:application-wizard/end-successfully-issued] [site-address recipient-name])
            (tr [:application-wizard/end-successfully-issued-no-address] [recipient-name]))

          issuing?
          (if site-address
            (tr [:application-wizard/end-issuing] [site-address recipient-name])
            (tr [:application-wizard/end-issuing-no-address] [recipient-name]))

          pre-con?
          (tr [:application-wizard/end-pre-consultation-created] [recipient-name])

          :else
          (tr [:application-wizard/end-successfully-submitted] [recipient-name]))]
       [:p.text-center.text-gray-800.mb-10
        (tr [(cond
               pre-con? :application-wizard/end-pre-consultation-info
               issued?  :application-wizard/end-issued-workspace-info
               issuing? :application-wizard/end-issuing-workspace-info
               :else    :application-wizard/end-workspace-info)])]
       [:div.flex.flex-row.flex-wrap.justify-center.gap-4
        (cc/button {:kind     :tertiary
                    :on-click #(>evt [:route/push :dashboard])}
                   (tr [:application-wizard/end-go-to-dashboard]))
        (cc/button {:kind     :primary
                    :on-click #(>evt [:route/push {:route  proceed-route
                                                   :params {:workspace-id workspace-id}}])}
                   (tr [:application-wizard/end-proceed-to-workspace]))]]]]))

;; Route for the post-submit / post-create splash screen — nested under workspace/:workspace-id.
(def workspace-wizard-end-route
  {:name             :view/application-wizard-end
   :view             end-view
   :hide-breadcrumb? true
   :hide-footer?     true})
